'use strict';

angular.module('dekky.forms.utils', [])
	.service('formsUtils', function () {
		this.camelToDash = function (str) {
			return str.replace(/\W+/g, '-')
				.replace(/([a-z\d])([A-Z])/g, '$1-$2');
		};

        /**
         * Функция возвращает окончание для множественного числа слова на основании числа и массива окончаний
         *
         * number Число на основе которого нужно сформировать окончание
         * array Массив слов или окончаний для чисел [1, 4, 5],
         *
         * например array['яблоко', 'яблока', 'яблок']
         */
		this.numEnding = function ( number, array ) {
            number = number % 100;

            if (number >= 11 && number <= 19) {
                var ending = array[2];
            } else {
                var i = number % 10;

                switch ( i ) {
                    case 1:
                        var ending = array[0];
                        break;
                    case 2:
                    case 3:
                    case 4:
                        var ending = array[1];
                        break;
                    default:
                        var ending = array[2];
                        break;
                }
            }

            return ending;
		}
	});